module.exports = __webpack_public_path__ + "static/media/brightness.0a7ef247.svg";